import { put, PutEffect } from 'redux-saga/effects';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import toast from '@helpers/toast';

/**
 * Standard error handler for all stone sagas.
 * Shows a toast with the parsed error message and returns
 * a put effect with the error message string.
 *
 * Usage: yield handleSagaError(error, failureAction, 'Fallback message');
 */
export function handleSagaError(error: any, failureAction: ActionCreatorWithPayload<string>, fallbackMessage: string): PutEffect {
  toast.error(toast.parseErrorMessage(error, fallbackMessage));
  return put(failureAction(String(error.message)));
}
